const SUCCESS_TYPE = "success";
const INFORMATION_TYPE = "info";
const ERROR_TYPE = "error";

export default class Alert {
  constructor(alertName) {
    this.time = new Date();
    switch (alertName) {
      case "notAWebsiteCreator":
        this.description = "alert.notAWebsiteCreator";
        this.type = ERROR_TYPE;
        break;
      case "notAYoutubeCreator":
        this.description = "alert.notAYoutubeCreator";
        this.type = ERROR_TYPE;
        break;
      case "postCreated":
        this.description = "alert.postCreated";
        this.type = SUCCESS_TYPE;
        break;
      case "postConfirmed":
        this.description = "alert.postConfirmed";
        this.type = SUCCESS_TYPE;
        break;
      case "postEdited":
        this.description = "alert.postEdited";
        this.type = SUCCESS_TYPE;
        break;
      case "postArchived":
        this.description = "alert.postArchived";
        this.type = SUCCESS_TYPE;
        break;
      case "profileUpdated":
        this.description = "alert.profileUpdated";
        this.type = SUCCESS_TYPE;
        break;
      case "pictureProfileUpdated":
        this.description = "alert.pictureProfileUpdated";
        this.type = SUCCESS_TYPE;
        break;
      case "tooBigPictureProfile":
        this.description = "alert.tooBigPictureProfile";
        this.type = ERROR_TYPE;
        break;
      case "noPictureProfile":
        this.description = "alert.noPictureProfile";
        this.type = ERROR_TYPE;
        break;
      case "wrongFilePictureProfile":
        this.description = "alert.wrongFilePictureProfile";
        this.type = ERROR_TYPE;
        break;
      case "successfullyLogout":
        this.description = "alert.successfullyLogout";
        this.type = INFORMATION_TYPE;
        break;
      case "sucessfullyLogin":
        this.description = "alert.sucessfullyLogin";
        this.type = INFORMATION_TYPE;
        break;
      case "pictureOverMaxSize":
        this.description = "alert.pictureOverMaxSize";
        this.type = ERROR_TYPE;
        break;
      case "fileIsNotAPicture":
        this.description = "alert.fileIsNotAPicture";
        this.type = ERROR_TYPE;
        break;
      case "pictureUploadError":
        this.description = "alert.pictureUploadError";
        this.type = ERROR_TYPE;
        break;
    }
  }
}
